import { IonCard, IonCardContent, IonCardHeader, IonCardTitle } from "@ionic/react";

const AccessDenied: React.FC = () => {
  return (
    <div style={{ display: "flex", justifyContent: "center", marginTop: "10vh" }}>
      <IonCard style={{ maxWidth: 500, width: "100%" }}>
        <IonCardHeader>
          <IonCardTitle color="danger">Access Denied</IonCardTitle>
        </IonCardHeader>
        <IonCardContent>
          <p>
            You do not have permission to access the Covers Manager.
          </p>
          <p style={{ marginTop: 12 }}>
            This application requires both the <strong>covers_admin</strong> and{" "}
            <strong>absence_admin</strong> permissions.
            Please contact your system administrator if you believe you should have access.
          </p>
        </IonCardContent>
      </IonCard>
    </div>
  );
};

export default AccessDenied;
